import React from "react";
import { useTranslation } from "react-i18next";

import { template } from "lodash";
import { format } from "date-fns";
import cn from "classnames";

import {
    IWorkflowStep,
    WorkflowStepStatus,
} from "store/workflows/workflows-types";

import "./Item.less";
import parse from "html-react-parser";

interface Props {
    step: IWorkflowStep;
}

const Item: React.FC<Props> = ({ step }: Props) => {
    const { t } = useTranslation();

    const getRenderSettings = (status: WorkflowStepStatus) => {
        switch (status) {
            case WorkflowStepStatus.Processing:
                return {
                    modifier: "step-item--in-process",
                    template: t("workflow.step.inProgress"),
                    showDate: false,
                };
            case WorkflowStepStatus.Completed:
                return {
                    modifier: "step-item--completed",
                    template: t("workflow.step.common"),
                    showDate: true,
                };
            case WorkflowStepStatus.Failed:
                return {
                    modifier: "step-item--failed",
                    template: t("workflow.step.failed"),
                    showDate: true,
                };
            case WorkflowStepStatus.Skipped:
                return {
                    modifier: "step-item--skipped",
                    template: t("workflow.step.skipped"),
                    showDate: true,
                };
            default:
                return {
                    modifier: "step-item--pending",
                    template: t("workflow.step.common"),
                    showDate: false,
                };
        }
    };

    const settings = getRenderSettings(step.status);
    const logs: string[] =
        step.logs !== null ? JSON.parse(step.logs ?? "") : null;

    const showError = step.status === WorkflowStepStatus.Failed;

    const descriptionTemplate = template(settings.template);

    return (
        <li className={cn("step-item", settings.modifier)}>
            <div className="step-item__description">
                {descriptionTemplate({ message: step.description ?? "" })}

                {logs !== null && (
                    <ul>
                        {logs.map((log, index) => (
                            <li key={index}>{parse(log)}</li>
                        ))}
                    </ul>
                )}
            </div>

            {settings.showDate && step.createdOn && (
                <div className="step-item__date-time">
                    {format(new Date(step.createdOn), "d MMMM y - HH:mm:ss")}
                </div>
            )}

            {showError && step.errorMessage && (
                <div className="step-item__error-stack">
                    {step.errorMessage}
                </div>
            )}
        </li>
    );
};

export default Item;
